import {
  RecurrenceScheduleDateStatus,
  RecurringInvoice
} from "@wingspanhq/wingspan-api-sdk";
import { getLocalStartDayByUTC, getStartOfDay } from "../../utils/dates";

const BILLABLE_STATUSES: Array<RecurrenceScheduleDateStatus | undefined> = [
  undefined,
  RecurrenceScheduleDateStatus.PENDING,
  RecurrenceScheduleDateStatus.MODIFIED
];

export const selectorRemainingOccurrenceCount = (
  recurringInvoice: RecurringInvoice
): number =>
  (recurringInvoice.schedule?.scheduleDates ?? []).filter(
    scheduleDate =>
      BILLABLE_STATUSES.includes(scheduleDate.status) &&
      getLocalStartDayByUTC(scheduleDate.date) >= getStartOfDay()
  ).length;
